import { Features, selectHasFeature } from "@/store/features/features-slice";
import { useAppSelector } from "@/store/store-hooks";
import { selectHasWritePermission } from "@/store/user-selectors";

/** @returns true if the entry points of the IPX ordering wizard should be shown */
export function useCanOrderFromIpx(): boolean {
  const isEnabled = useAppSelector(selectHasFeature(Features.IpxScanToBim));
  // Only editors can start jobs, the real token endpoint will enforce this too
  const canEdit = useAppSelector(selectHasWritePermission);
  return isEnabled && canEdit;
}
